import { Button as Btn, styled } from "@material-ui/core";

const Button = styled(Btn)({
    fontWeight   : 'normal',
    textTransform: 'none'
});

export default Button;